import React from 'react';

export const DescubreCarreterasIcon = (): React.ReactElement => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="211" height="227" viewBox="0 0 211 227" fill="none">
			<g clipPath="url(#clip0_6213_2095)">
				<path d="M123.127 1.74658H87.6641V225.254H123.127V1.74658Z" fill="#4cc7f4" />
				<path d="M124.836 227H85.8857V0H124.836V227ZM89.4076 223.507H121.384V3.49285H89.4076V223.507Z" fill="#001e50" />
				<path
					d="M172.05 49.0046L72.1121 78.9033L62.209 45.6864L162.112 15.7876L190.113 25.4977L172.05 49.0046Z"
					fill="#4cc7f4"
				/>
				<path
					d="M70.9613 81.0687L60.0469 44.4987L162.182 13.9712L193.007 24.6593L173.096 50.5413L70.9613 81.1037V81.0687ZM64.3708 46.8738L73.2976 76.7376L171.004 47.5025L187.288 26.3708L162.112 17.6387L64.4057 46.8738H64.3708Z"
					fill="#001e50"
				/>
				<path d="M147.845 35.9696L75.9287 57.5542L76.9296 60.9001L148.846 39.3154L147.845 35.9696Z" fill="#001e50" />
				<path
					d="M20.5733 101.781L143.212 120.154L149.349 78.8333L26.7453 60.4609L2.47559 77.9601L20.5733 101.781Z"
					fill="#4cc7f4"
				/>
				<path
					d="M144.677 122.144L19.632 103.423L0 77.5757L26.2922 58.6445L151.337 77.3662L144.642 122.144H144.677ZM21.5498 100.174L141.748 118.163L147.397 80.3002L27.1988 62.312L4.95158 78.3442L21.5498 100.174Z"
					fill="#001e50"
				/>
				<path d="M41.073 81.5621L40.5576 85.0166L137.501 99.5291L138.017 96.0746L41.073 81.5621Z" fill="#001e50" />
				<path
					d="M180.872 88.9629L48.6787 122.11L57.8147 158.68L190.008 125.568L208.28 101.537L180.872 88.9629Z"
					fill="#001e50"
				/>
				<path
					d="M56.5598 160.811L46.5869 120.852L181.047 87.1465L211 100.873L191.02 127.105L190.427 127.244L56.5598 160.811ZM50.8062 123.367L59.1053 156.549L188.997 123.996L205.595 102.201L180.733 90.814L50.8411 123.367H50.8062Z"
					fill="#001e50"
				/>
				<path d="M149.312 114.954L62.1582 136.737L63.0024 140.126L150.156 118.343L149.312 114.954Z" fill="#4cc7f4" />
			</g>
			<defs>
				<clipPath id="clip0_6213_2095">
					<rect width="211" height="227" fill="#4cc7f4" />
				</clipPath>
			</defs>
		</svg>
	);
};
